import {
  applyGeoJsonLayerRenderer,
  type ApplyGeoJsonLayerRendererParams,
} from './geoJsonLayerRenderer';
import {
  buildSurveyTravelDirectionSymbol,
  orientLayerFeaturesToCourseBearing,
} from './surveyTravelDirection';

type MutableRenderer = {
  type?: string;
  symbol?: Record<string, unknown>;
  defaultSymbol?: Record<string, unknown>;
  uniqueValueInfos?: Array<{ symbol?: Record<string, unknown> }>;
};

export interface ApplySurveyCoverageLayerRendererParams
  extends ApplyGeoJsonLayerRendererParams {
  readonly mapZoom: number;
}


export function applySurveyCoverageLayerRenderer(
  params: ApplySurveyCoverageLayerRendererParams,
): void {
  const { mapZoom, ...rendererParams } = params;
  applyGeoJsonLayerRenderer(rendererParams);

  const { layer } = rendererParams;
  const geometryType = layer.geometryType;
  if (
    geometryType === 'point' ||
    geometryType === 'multipoint' ||
    geometryType == null
  ) {
    return;
  }

  const renderer = layer.renderer as MutableRenderer | undefined;
  if (!renderer) {
    return;
  }

  if (renderer.type === 'simple' && renderer.symbol) {
    renderer.symbol = buildSurveyTravelDirectionSymbol(
      { ...renderer.symbol },
      mapZoom,
    );
  } else if (renderer.type === 'unique-value') {
    if (renderer.defaultSymbol) {
      renderer.defaultSymbol = buildSurveyTravelDirectionSymbol(
        { ...renderer.defaultSymbol },
        mapZoom,
      );
    }
    if (Array.isArray(renderer.uniqueValueInfos)) {
      renderer.uniqueValueInfos = renderer.uniqueValueInfos.map((info) => ({
        ...info,
        symbol: info.symbol
          ? buildSurveyTravelDirectionSymbol({ ...info.symbol }, mapZoom)
          : info.symbol,
      }));
    }
  }

  layer.renderer = renderer;
  void orientLayerFeaturesToCourseBearing(layer);
}
